import { useCallback, useEffect, useMemo } from 'react'
import { useFetch } from 'civic-champs-shared/api/hooks'

const useCampaignEvents = campaign => {
  const [request, { result, loading, error }] = useFetch()
  const getCampaignEvents = useCallback(() => {
    return request({
      method: 'get',
      url: `/campaigns/${campaign.id}/campaign_events`,
    })
  }, [request, campaign.id])

  useEffect(() => {
    getCampaignEvents()
  }, [getCampaignEvents])

  return {
    refresh: getCampaignEvents,
    campaignEvents: result,
    loading,
    error,
  }
}

export default useCampaignEvents
